module.exports = __webpack_public_path__ + "img/20210117_105133.bb8351ee.jpg";